@use '@lib/assets/styles/main.scss' as *;
.filterWrap {
  padding-bottom: 16px;
}

.filter {
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  row-gap: 8px;
  column-gap: 16px;
}

.dateRangePickerCol {
  width: 288px; // DatePicker drop-down width
}

.assetCol {
  max-width: 264px;
}

.siteAreaFilter {
  padding: 8px 16px;
}

.siteAndAreaFormActions {
  align-self: flex-end;
  margin-top: -32px;
  position: relative;
  z-index: 2;
}

.optionWrap {
  position: relative;
  &.optionWrapWithDelete {
    padding-right: 48px;
  }
}

.optionDeleteBtn {
  position: absolute;
  top: 8px;
  right: 0;
}

.optionAddBtn {
  padding-top: 16px;
  display: flex;
  justify-content: space-between;
}

.periodFormActions {
  padding: 0 16px 16px;
}

.optionAddBtnWithTopPadding {
  position: relative;
}
